import { useMemo } from 'react';

import { FieldBlock } from '../../../UIPackage/FormModule/components/FieldBlock';
import { IKnmMassDelete } from '../../../APIPackage/KnmModule/interfaces/IKnmMassDelete';
import { DatePicker } from '../../../UIPackage/MainModule/components/DatePicker';
import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import {
  DATE_FORMAT_ISO_FNS,
  DATE_FORMAT_LONG_MINUTE_FNS,
} from '../../../CorePackage/MainModule/constants/dateFormats';
import { TextInput } from '../../../UIPackage/MainModule/components/TextInput';
import styles from './MassDeleteInfo.module.scss';

interface IMassDeleteInfoProps {
  massDelete: IKnmMassDelete | null | undefined;
}

export const MassDeleteInfo = ({ massDelete }: IMassDeleteInfoProps) => {
  const deletedValue = useMemo(
    () =>
      formatDate({
        date: massDelete?.deleted || '',
        dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
        parseFormat: DATE_FORMAT_ISO_FNS,
      }),
    [massDelete],
  );

  if (!massDelete?.deleted) {
    return null;
  }

  return (
    <FieldBlock label="Сведения об удалении мероприятия" margin="bottom" className={styles.MassDeleteInfoBlock}>
      <FieldBlock label="Дата и время отмены" color="black" placementLabel="left" margin="bottom" labelSize="col-3">
        <DatePicker name="" value={deletedValue} className="shared-row-field" disabled={true} />
      </FieldBlock>
      <FieldBlock
        label="Основание массового удаления"
        color="black"
        placementLabel="left"
        margin="bottom"
        labelSize="col-3"
      >
        <TextInput className="shared-row-field" value={massDelete.reason?.name} disabled={true} />
      </FieldBlock>
      <FieldBlock
        label="Номер группы мероприятий, подлежащих удалению"
        color="black"
        placementLabel="left"
        margin="bottom"
        labelSize="col-3"
      >
        <TextInput className="shared-row-field" value={massDelete.groupId} disabled={true} />
      </FieldBlock>
    </FieldBlock>
  );
};
